import { ScreenshotContext } from "@/_screenshots/screenshot.provider.tsx";
import { useContext } from "react";

export const useScreenshotContext = () => useContext(ScreenshotContext);
